export const campaignsApiPath = {
  /** 쿠폰 캠페인 제안 목록 조회 */
  getProposals: '/v2/curator/campaign/coupon/proposals',
  /** 쿠폰 캠페인 제안 상세 조회 */
  getProposal: (campaignProposalId: number) =>
    `/v2/curator/campaign/coupon/proposals/${campaignProposalId}`,
  /** 캠페인 제안 > 연관 상품 조회 */
  getProposalGoods: (campaignProposalId: number) =>
    `/v2/curator/campaign/coupon/proposals/${campaignProposalId}/goods`,
  /** 쿠폰 캠페인 제안 수락 */
  postProposalApprove: (campaignProposalId: number) =>
    `/v2/curator/campaign/coupon/proposals/${campaignProposalId}/approve`,
  /** 쿠폰 캠페인 제안 거절 */
  putProposalReject: (campaignProposalId: number) =>
    `/v2/curator/campaign/coupon/proposals/${campaignProposalId}/reject`,
  /** 쿠폰 캠페인 역제안 목록 조회 */
  getReverseProposals: '/v2/curator/campaign/coupon/reverse-proposals',
  /** 쿠폰 캠페인 역제안 요청 */
  postReverseProposal: '/v2/curator/campaign/coupon/reverse-proposals',
  /** 쿠폰 캠페인 역제안 상세 조회 */
  getReverseProposal: (reverseProposalId: number) =>
    `/v2/curator/campaign/coupon/reverse-proposals/${reverseProposalId}`,
  /** 역제안 > 상품 검색 */
  getReverseProposalGoods: '/v2/curator/campaign/coupon/reverse-proposals/goods',
  /** 역제안 > 상품 상세 조회 */
  getReverseProposalGoodsDetail: (goodsNo: number) =>
    `/v2/curator/campaign/coupon/reverse-proposals/goods/${goodsNo}`,
  /** 역제안 > 약관 동의 브랜드 조회 */
  getReverseProposalBrands: '/v2/curator/campaign/coupon/reverse-proposals/brands',
  /** 시딩 - 모집형 캠페인 목록 */
  getRecruitment: '/v2/curator/campaign/seeding/recruitment',
  /** 시딩 - 모집형 캠페인 목록 카테고리 탭 */
  getRecruitmentCategories: '/v2/curator/campaign/seeding/recruitment/categories',
  /** 시딩 캠페인 진행중 목록 조회 (홈 진행 중 캠페인 섹션) */
  getInProgressCampaigns: '/v2/curator/campaign/seeding/in-progress',
  /** 시딩 - 내가 신청한 모집형 캠페인 목록 */
  getSeedingMeRecruitment: '/v2/curator/campaign/seeding/me/recruitment',
  /** 시딩 - 내가 신청한 모집형 캠페인 상태별 카운트 */
  getSeedingMeRecruitmentCount: '/v2/curator/campaign/seeding/me/recruitment/count',
  /** 시딩 - 제안 받은 캠페인 목록 */
  getSeedingMeProposal: '/v2/curator/campaign/seeding/me/proposal',
  /** 시딩 - 제안 받은 캠페인 상태별 카운트 */
  getSeedingMeProposalCount: '/v2/curator/campaign/seeding/me/proposal/count',
  /** 시딩 - 제안 수락 */
  postSeedingProposalAccept: (participationId: number) =>
    `/v2/curator/campaign/seeding/proposals/${participationId}/accept`,
  /** 시딩 - 제안 거절 */
  postSeedingProposalReject: (participationId: number) =>
    `/v2/curator/campaign/seeding/proposals/${participationId}/reject`,
  /** 시딩 - 제안 거절 사유 목록 */
  getSeedingProposalRejectionReasons: '/v2/curator/campaign/seeding/proposal/rejection-reasons',
  /** 시딩 - 큐레이터 배송지 목록 (29CM 한정) */
  getSeedingDeliveryAddresses: '/v2/curator/campaign/seeding/delivery-addresses',
  /**
   * 시딩 캠페인 상세 조회 (모집형/제안형 공용 단일 엔드포인트, SID-2659).
   *
   * BE 는 모집/제안을 통일 응답으로 서빙하고, FE 가 `campaign.campaignType`(RECRUITMENT|PROPOSAL)
   * 로 화면을 분기한다. recruitment/proposal/campaignDetail 모두 같은 path 를 호출한다.
   */
  getSeedingRecruitmentDetail: (campaignId: number) => `/v2/curator/campaign/seeding/${campaignId}`,
  /** @deprecated 통일 단일 엔드포인트로 합쳐짐 — getSeedingRecruitmentDetail 과 동일 path. */
  getSeedingProposalDetail: (campaignId: number) => `/v2/curator/campaign/seeding/${campaignId}`,
  /** 모집형 시딩 캠페인 신청 */
  applyRecruitmentCampaign: (campaignId: number) =>
    `/v2/curator/campaign/seeding/recruitment/${campaignId}/apply`,
  /** 시딩 제안 수락 */
  acceptSeedingProposal: (participationId: number) =>
    `/v2/curator/campaign/seeding/proposals/${participationId}/accept`,
  /** 시딩 제안 거절 */
  rejectSeedingProposal: (participationId: number) =>
    `/v2/curator/campaign/seeding/proposals/${participationId}/reject`,
  /** 모집형 시딩 캠페인 신청 취소 */
  cancelRecruitmentApplication: (participationId: number) =>
    `/v2/curator/campaign/seeding/recruitment/${participationId}/cancel`,
  /** 시딩 콘텐츠 링크 제출 */
  submitSeedingContent: (participationId: number) =>
    `/v2/curator/campaign/seeding/participations/${participationId}/submissions`,
  /** 큐레이터 상품 옵션 조회 */
  getSeedingProductOptions: (campaignId: number) =>
    `/v2/curator/campaign/seeding/${campaignId}/products/options`,
  /** 시딩 캠페인 배송지 수정 (PUT, 0610) */
  updateDeliveryAddress: (campaignId: number) =>
    `/v2/curator/campaign/seeding/${campaignId}/delivery`,
} as const;
